export const REST_URI_PREFIX = "";
export const WEBSOCKET_URI_PREFIX = "/web-socket/websocket";

/**
 * Overridable web server uri
 */
export const getWebServerUri = () => {
  return import.meta.env.VITE_API_URL || window.location.origin;
};
/**
 * Get web server uri with predefined prefix
 * @param prefix rest uri prefix
 */
export const getRestServiceUri = (prefix: string = REST_URI_PREFIX) => {
  return getWebServerUri() + prefix;
};
